export const BasicInformation = {
companyName: 'Partex Tissue Limited.',
address: 'Shanta Western Tower, Level – 13 Bir Uttam Mir Shawkat Road, 186 Tejgaon I/A Dhaka – 1208, Bangladesh',
email: 'mail@phgbd.com',
phone: "+88 02 8878800-11"

}

export const FooterInfo = {
    year: '2025',
    email: 'mail@phgbd.com',
    phone: '+88 02 8878800-11'
}

export const ContactInformation = {
    address: 'Shanta Western Tower, Level – 13 Bir Uttam Mir Shawkat Road, 186 Tejgaon I/A Dhaka – 1208, Bangladesh',
    email: 'mail@phgbd.com',
    phone: "+88 02 8878800-11"
}

export const SocialMediaLink = {
    facebook: 'www.facebook.com',
    linkdin: 'www.linkdin.com',
    twiter: 'www.twiter.com'
} 
